<app-filter-header title="Filtrar colors" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="color-filter-descripcio" class="col-sm-9" i18n-label label="Descripció" [(value)]="filter.descripcio" contains></app-filter-text-edit>
    <app-filter-text-edit id="carrer-filter-codi" class="col-sm-3" i18n-label label="Codi propi" [(value)]="filter.codiPropi" contains></app-filter-text-edit>
  </div>
</div>
